import type { ReactNode } from "react";
import { cx } from "../cx.js";
import styles from "./Panel.module.css";

export interface PanelProps {
  eyebrow?: ReactNode;
  title?: ReactNode;
  titleLevel?: 1 | 2 | 3;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
  id?: string;
}

export function Panel({ eyebrow, title, titleLevel = 2, children, actions, className, id }: PanelProps) {
  const H = `h${titleLevel}` as const;
  return (
    <section
      className={cx(styles.panel, className)}
      aria-labelledby={title && id ? `${id}-title` : undefined}
    >
      {eyebrow || title ? (
        <header className={styles.header}>
          {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
          {title ? (
            <H className={styles.title} id={id ? `${id}-title` : undefined}>
              {title}
            </H>
          ) : null}
        </header>
      ) : null}
      {children}
      {actions ? <footer className={styles.actions}>{actions}</footer> : null}
    </section>
  );
}
